var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-row',{staticClass:"ma-0 pa-0 audience-pie-chart",attrs:{"justify":"start"}},[_c('v-col',{staticClass:"ma-0 pa-0 audience-pie-chart__canvas",attrs:{"cols":"12"}},[_c('v-chart',{staticClass:"chart",attrs:{"option":_vm.graph_options,"autoresize":""}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }